import type { Melody, MelodyEntityNote, MelodySource } from '@tunasong/schemas'

/**
 * Write a capture into a melody.
 *
 * Only `notes` and `source` change. A re-capture is a new performance of the same melody, not a new
 * melody: the tempo, meter, grid, key, feel and instrument hint were the user's decisions before the
 * take and are still theirs after it.
 *
 * The previous `source.entityId` is dropped from the melody but the ENTITY it named is never deleted
 * (§2). A recording is a thing the user made; the melody merely stops pointing at it.
 *
 * Spec: docs/superpowers/specs/2026-09-08-melody-plugin-design.md §2, §5
 */
export const applyCapture = (melody: Melody, notes: MelodyEntityNote[], source: MelodySource): Melody => ({
  ...melody,
  notes,
  source,
})
